import { Pie } from "react-chartjs-2";

import ChartCard from "./ChartCard";

import {
    buildChartLabels,
    buildChartValues,
} from "../../../utils/admin/chartUtils";

import {
    CHART_COLORS,
} from "../../../constants/admin/chart/chartConstants";

const ChartUserRole = ({ data }) => {
    return (
        <ChartCard title="Số người dùng theo vai trò">
            <Pie
                data={{
                    labels: buildChartLabels(
                        data,
                        "role"
                    ),

                    datasets: [
                        {
                            label: "Số người dùng",

                            data: buildChartValues(data),

                            backgroundColor: [
                                CHART_COLORS.teal,
                                CHART_COLORS.purple,
                                CHART_COLORS.orange,
                            ],
                        },
                    ],
                }}
                options={{
                    responsive: true,

                    plugins: {
                        legend: {
                            position: "right",
                            labels: {
                                boxWidth: 20,
                                padding: 15,
                            },
                        },
                    },
                }}
            />
        </ChartCard>
    );
};

export default ChartUserRole;